import { defineStore } from "pinia";

export const useAppSidebarMenuStore = defineStore({
  id: "appSidebarMenu",
  state: () => {
    return [
		{
			text: 'Navigation',
			is_header: true
		},
		{
			url: '/abbr', icon: 'fa fa-sitemap', title: 'Abbreviation',
			children: [
				{ name: 'abbr-dashboard', title: 'Dashboard' },
				{ name: 'abbr-project', title: 'Project' }
			]
		}]
  }
});